import { debounce } from 'lodash-es';
import { useLayoutEffect, useState } from 'react';

interface Size {
  width: number;
  height: number;
}

export default function useElementSize<T extends HTMLElement = HTMLDivElement>(
  wait = 100
): [(node: T | null) => void, Size] {
  const [ref, setRef] = useState<T | null>(null);
  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0,
  });

  useLayoutEffect(() => {
    if (!ref) return;

    const handleSize = debounce(() => {
      setSize({
        width: ref.offsetWidth,
        height: ref.offsetHeight,
      });
    }, wait);

    handleSize();

    // We don't want leading: true but we do want the initial render to run immediately
    handleSize.flush();

    window.addEventListener('resize', handleSize);
    return () => window.removeEventListener('resize', handleSize);
  }, [ref, wait]);

  return [setRef, size];
}
